<template>
  <v-overlay
    :absolute="false"
    :value="overlay"
    :opacity="0.9"
    >
    <v-progress-circular
      indeterminate
      color="amber"
      :size="70"
      :width="7"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
  export default {
    name: 'Spinner',
    props: ['overlay']
  }
</script>
